const storage = {
  history: null,
  historyResolve: null,
}

export function registerHistoryService(history) {
  storage.history = history;
  storage.historyResolve && storage.historyResolve(history);
}

export async function getHistoryService() {
  if (storage.history) { return storage.history }

  return await new Promise((resolve, reject) => {
    storage.historyResolve = resolve;
  });
}